import { get } from "#api";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import logo from "#resource/logo.png";

function MyCats() {
  const query = useQuery({
    queryKey: ["my_animals"],
    queryFn: async () => {
      const data = await get(`/animal/me`);
      return data;
    },
    initialData: [],
  });
  const navigate = useNavigate();

  return (
    <div className="p-6 bg-gray-200 rounded-md shadow-md">
      <div>My Animals</div>
      <ul
        role="list"
        className="pt-6 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3"
      >
        {query.data.map((animal) => (
          <li
            onClick={() => navigate(`/animal/${animal.animalId}`)}
            key={animal.email}
            className="col-span-1 divide-y divide-gray-200 rounded-lg bg-white shadow-sm hover:shadow-lg hover:bg-gray-100 dark:divide-white/10 dark:bg-gray-800/50 dark:shadow-none dark:outline dark:-outline-offset-1 dark:outline-white/10"
          >
            <div className="p-2 flex flex-col items-center gap-4">
              <img
                alt="..."
                src={animal.imageUrl ?? logo}
                className="mt-2 shrink-0 rounded-sm bg-gray-300 outline -outline-offset-1 outline-black/5 dark:bg-gray-700 dark:outline-white/10"
              />
              <div className="flex-1 truncate">
                <div className="flex flex-col gap-1 items-center ">
                  <h3 className="truncate text-lg font-semibold text-gray-900 dark:text-white">
                    {animal.name}
                  </h3>
                  <span className="inline-flex shrink-0 items-center rounded-full bg-green-50 px-1.5 py-0.5 text-xs font-medium text-green-700 inset-ring inset-ring-green-600/20 dark:bg-green-500/10 dark:text-green-500 dark:inset-ring-green-500/10">
                    {animal.color} ({animal.coat})
                  </span>
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default MyCats;
